import { LocationNumbersService } from '../../../services'

const fetchNumberPool = async function ({ commit, state, getters, dispatch }, config) {
  let tableConfig
  const { numberPools, payload, getPaginatedDataOnly = false } = config

  /**
   * If numberPools is empty then there's no need to fetch detailed number pool data
   * simply return an empty array and set rendered records count to 0
   */
  if (!numberPools?.length) {
    commit('setTableRecordsCount', 0)
    return Promise.resolve([])
  }

  /**
   * If payload is not provided, then we are fetching
   * the phone numbers from the state table
   */
  if (!payload) {
    tableConfig = {
      limit: state.table?.limit,
      page: state.table?.currentPage,
      query: state.table?.searchText ?? '',
    }
  }

  const table = payload ?? tableConfig

  if (getPaginatedDataOnly) {
    const result = await dispatch('fetchLocalNumberPools', {
      paginationConfig: table,
    })

    return Promise.resolve(result)
  }

  commit('startLoading')
  try {
    const data = await LocationNumbersService.getNumberPools(numberPools)

    const mappedNumberPools = data.map((datum: any) => ({
      ...datum.data,
      id: datum.id,
    }))
    commit('setNumberPoolIDs', numberPools)
    commit('setNumberPools', mappedNumberPools)
    commit('setNumberPoolsLookupTable', 'id')
    commit('setTableRecordsCount', data?.length)
    commit('setTable', table)
    commit('stopLoading')

    const result = getters.getPaginatedNumberPools
    return Promise.resolve(result)
  } catch (error) {
    commit('stopLoading')
    return Promise.reject(error)
  }
}

export default fetchNumberPool
